export interface RememberPass {
    code: string;
    message: string;
}

export class RememberPassHelper {

    static create(): RememberPass {
        return {
            code: '',
            message: ''
        };
    }

    static transformFromApi(apiData: Object) {
        const rememberPass = RememberPassHelper.create();
        rememberPass.code = apiData['CODIGO'];
        rememberPass.message = apiData['MENSAJE'];
        return rememberPass;
    }
}
